document.addEventListener('DOMContentLoaded', function () {
  // Multishipping page: "Ausgewählte Artikel als Geschenk versenden" now acts as a "back to cart" button.
  var gsToggleBox = document.querySelector('#gsMultishippingPage #gs__toggle-box');
  if (gsToggleBox) {
    gsToggleBox.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/cart/';
    });
  }
});

// Multishipping page: keep the header cart count bubble in sync with the real cart state.
function gsApplyCartIconBubble(sections) {
  var bubble = document.getElementById('cart-icon-bubble');
  var section = sections && sections['cart-icon-bubble'];
  if (!bubble || !section) return;

  bubble.innerHTML = new DOMParser()
    .parseFromString(section, 'text/html')
    .querySelector('.shopify-section').innerHTML;
}

// Read-only refresh: re-renders the cart icon bubble from the current cart state
// without changing any line item (used after the app adds/splits recipient rows).
function gsRefreshCartIconBubble() {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: {}, sections: 'cart-icon-bubble' })
  })
    .then(function (res) { return res.json(); })
    .then(function (cart) { gsApplyCartIconBubble(cart.sections); });
}

// Quantity changed via a .gs__ct-qty-val input (typing) or a +/- .gs__ct-qty-btn stepper.
// The multishipping app owns the actual cart update for these rows, so we just
// re-sync the header bubble afterwards rather than issuing our own /cart/change.js call.
(function () {
  var debounceTimer;
  function scheduleGsBubbleRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(gsRefreshCartIconBubble, 700);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.gs__ct-qty-val')) {
      scheduleGsBubbleRefresh();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.gs__ct-qty-btn')) {
      scheduleGsBubbleRefresh();
    }
  });

  // New recipient row (e.g. "Weiterer Empfänger") added to the multishipping cart -
  // the app updates the cart itself, so just re-sync the header bubble afterwards.
  new MutationObserver(function (mutations) {
    var hasNewRow = mutations.some(function (mutation) {
      return [].slice.call(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 &&
          (node.matches?.('.gs__ct-card') || node.querySelector?.('.gs__ct-qty-val'));
      });
    });

    if (!hasNewRow) return;

    scheduleGsBubbleRefresh();
  }).observe(document.body, { childList: true, subtree: true });
})();
